import React from "react";
import Navbar from "./Navbar";

const NavigationBar = ({
  open,
  setOpen,
  sections,
  collapsedSections,
  toggleSection,
  showMinimizeButton,
  useCurrentPage,
  showAssistantSelector = true
}) => (
  <Navbar
    sections={sections}
    collapsedSections={collapsedSections}
    toggleSection={toggleSection}
    showAssistantSelector={showAssistantSelector}
    useCurrentPage={useCurrentPage}
    open={open}
    setOpen={setOpen}
    showMinimizeButton={showMinimizeButton}
  />
);

export default NavigationBar;
